import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getSpecialMessagesContent = createAsyncThunk(
  "/special-messages/content",
  async () => {
    const response = await axios.get("/api/users?page=2", {});
    return response.data;
  },
);

export const specialMessagesSlice = createSlice({
  name: "special-messages",
  initialState: {
    isLoading: false,
    messages: [],
  },
  reducers: {
    addNewSpecialMessage: (state, action) => {
      let { newMessageObj } = action.payload;
      state.messages = [...state.messages, newMessageObj];
    },

    deleteSpecialMessage: (state, action) => {
      let { index } = action.payload;
      state.messages.splice(index, 1);
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getSpecialMessagesContent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSpecialMessagesContent.fulfilled, (state, action) => {
        state.messages = action.payload.data;
        state.isLoading = false;
      })
      .addCase(getSpecialMessagesContent.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { addNewSpecialMessage, deleteSpecialMessage } = specialMessagesSlice.actions;

export default specialMessagesSlice.reducer;
